module.exports = __webpack_public_path__ + "assets/record-video-btn-icon.png";


//////////////////
// WEBPACK FOOTER
// ./images/ai-preview/record-video-btn-icon.png
// module id = 559
// module chunks = 0